import { useQuery } from '@apollo/client';

import { SocialUserSearchDocument } from './social-user-search.gql-types';
import { MentionUser } from './types';

export type useMentionQueryProps = (query?: string) => {
  users: MentionUser[];
  loading: boolean;
  hasError: boolean;
};

export const useMentionQuery: useMentionQueryProps = (query = '') => {
  const { data, error, loading } = useQuery(SocialUserSearchDocument, {
    variables: { query },
    fetchPolicy: 'no-cache',
  });

  const users: MentionUser[] = [];

  data?.viewer?.socialUserSearch?.collection?.forEach((element) => {
    if (!element) return;

    const { isMentionable, userId, user } = element;
    if (user?.displayName) {
      const { displayName, profileImage, occupations } = user;

      users.push({
        displayName,
        isMentionable: isMentionable === null ? undefined : isMentionable,
        occupationOrg: occupations?.[0]?.headline,
        profileImage: profileImage?.[0]?.url,
        userId,
      });
    }
  });

  return { users, loading, hasError: !!error };
};
